'use strict';

// Add init function that is executed on every page/fragment render
mpro.addInitStatic(($container) => {

	const $searchContainers = $container.find('[data-enhanced-search]');

	/* Check if there are any inputs on the page */
	if ($searchContainers.length) {
		import('./util').then(({ enhanceSearchForm }) => void enhanceSearchForm($searchContainers));
	}
});
